export const HTTP_HEADER = {
  'X-CSRF-Token': 'X-CSRF-TOKEN',
} as const;
